import styled from 'styled-components';
import { Subtitle1Styles } from '../typography';
import { getSizeBy } from '../../../src/styled/utils';
import { getCounterColor } from './counter';
export const StyledCounter = styled.div `
  ${Subtitle1Styles}
  position: absolute;
  top: ${({ $position }) => $position.vertical === 'top'
    ? '0'
    : $position.vertical === 'center'
        ? '50%'
        : $position.vertical === 'bottom'
            ? '100%'
            : '0'};
  left: ${({ $position }) => $position.horizontal === 'left'
    ? '0'
    : $position.horizontal === 'center'
        ? '50%'
        : $position.horizontal === 'right'
            ? '100%'
            : '0'};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${getSizeBy(3)};
  padding: 0 ${getSizeBy()} 0 ${getSizeBy()};
  color: ${({ $textColor }) => getCounterColor($textColor)};
  font-size: ${getSizeBy(2)};
  background-color: ${({ $backgroundColor }) => getCounterColor($backgroundColor)};
  border-radius: ${getSizeBy(25)};
  transform: ${({ $position }) => {
    let translateX = '0';
    let translateY = '0';
    if ($position.vertical === 'center') {
        translateY = '-50%';
    }
    else if ($position.vertical === 'bottom') {
        translateY = '-100%';
    }
    if ($position.horizontal === 'center') {
        translateX = '-50%';
    }
    else if ($position.horizontal === 'right') {
        translateX = '-100%';
    }
    return `translate(${translateX}, ${translateY})`;
}};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
`;
